<template>
  <div>
    <app-button type="outlined"
                @click="isOpen = true"
                data-locator="close-room-button"
    >
      <font-awesome-icon :icon="['far', 'ban']" class="mr-2" />
      {{ closeRoomButtonText }}
    </app-button>
    <AppDialog :is-open="isOpen"
               size="l"
               :ok-text="$t('common.confirm')"
               :ok-loading="closeRoomPending"
               :ok-disabled="closeRoomPending"
               :cancel-disabled="closeRoomPending"
               data-locator="settings-close-room-dialog"
               @ok="prepareCloseRoom"
               @cancel="resetAndClose"
    >
      <template #title>
        {{ $t('project.project-settings.ProjectSettingsCloseRoomDialog.closeProject') }}
      </template>
      <template #body>
        <app-alert-in-page
          v-if="closingInProgress"
          class="mb-6"
          variant="warning"
          :dismissible="false"
        >
          {{ $t('project.project-settings.ProjectSettingsCloseRoomDialog.closingInProgressWarning') }}
        </app-alert-in-page>
        <v-row>
          <v-col>
            <i18n-t keypath="project.project-settings.ProjectSettingsCloseRoomDialog.text1"
                    tag="p"
                    class="mb-3"
                    scope="global"
            >
              <template #warning>
                <span class="font-weight-bold">{{ $t("common.warning") }}</span>
              </template>
            </i18n-t>
            <p class="mb-3">{{ $t("project.project-settings.ProjectSettingsCloseRoomDialog.text2") }}</p>
            <p class="font-weight-bold">
              {{ $t('project.project-settings.ProjectSettingsCloseRoomDialog.text3', {date: deletionDate}) }}
            </p>

            <p class="mt-6">{{ $t('project.project-settings.ProjectSettingsCloseRoomDialog.notify') }}</p>
            <v-checkbox v-model="notifyPms"
                        :label="$t('project.project-settings.ProjectSettingsCloseRoomDialog.notifyPms')"
                        :disabled="forcedNotifications"
                        hide-details
                        data-locator="notify-project-managers-checkbox"
            />
            <v-checkbox v-model="notifyGuests"
                        :label="$t('project.project-settings.ProjectSettingsCloseRoomDialog.notifyGuests')"
                        :disabled="forcedNotifications"
                        hide-details
                        data-locator="notify-guests-checkbox"
            />
          </v-col>
        </v-row>
      </template>
    </AppDialog>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import { mapActions, mapGetters, mapState } from 'vuex'

import AppDialog from '@/common/dialogs/AppDialog.vue'
import { ISOToDDMMYYYY } from '@/common/utils/dates'
import { toast } from '@/common/utils/toast'
import { ROOMS_ROUTE_NAME } from '@/router'
import { CLOSE_ROOM } from '@/store/modules/room/action_types'

export default {
  name: 'ProjectSettingsCloseRoomDialog',
  components: { AppDialog },
  props: {
    mnemo: {
      type: String,
      required: true,
    },
  },
  data () {
    return {
      isOpen: false,
      notifyPms: true,
      notifyGuests: true,
    }
  },
  computed: {
    ...mapState('room', ['currentRoom', 'closeRoomPending']),
    ...mapGetters('room', ['isDataRoom']),
    ...mapGetters('user', ['areNotificationsForcedOnRoomClose']),
    deletionDate () {
      return ISOToDDMMYYYY(dayjs().add(1, 'month'))
    },
    closeRoomButtonText () {
      return this.isDataRoom
        ? this.$t('project.project-settings.ProjectSettingsCloseRoomDialog.closeDataRoom')
        : this.$t('project.project-settings.ProjectSettingsCloseRoomDialog.closeProject')
    },
    forcedNotifications () {
      return this.areNotificationsForcedOnRoomClose
    },
    closingInProgress () {
      return this.currentRoom.inClosing
    },
  },
  methods: {
    ...mapActions('room', [CLOSE_ROOM]),
    resetAndClose () {
      this.isOpen = false
      this.notifyPms = true
      this.notifyGuests = true
    },
    async prepareCloseRoom () {
      try {
        await this.CLOSE_ROOM({
          mnemo: this.mnemo,
          data: {
            notifyPms: this.notifyPms,
            notifyGuests: this.notifyGuests,
          },
        })
        toast.success(this.$t('project.project-settings.ProjectSettingsCloseRoomDialog.closeRoomSuccess'))
        this.$router.push({ name: ROOMS_ROUTE_NAME })
      } catch (error) {
        console.error(error)
        toast.error(this.$t('project.project-settings.ProjectSettingsCloseRoomDialog.closeRoomError'))
      }
    },
  },
}
</script>
